import React from "react";
import UnForm from "../../../../../Components/Form";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { CancelarCasoController } from "../../../../../Controllers/Geral/Atendimentos/AtendimentosController";
import { ICancelarCaso } from "../../../../../Interfaces/Geral/Atendimento/AtendimentoInterfaces";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import { useAtendimentoPage } from "../../../../../Context/AtendimentoPage";
import { useHistoricoContext } from "../../../../../Context/Historico";

interface IJustificativaCancelamentoFinalizarCaso {
    setShow: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function JustificativaCancelamentoFinalizarCaso(
    props: IJustificativaCancelamentoFinalizarCaso
) {
    const { ID_CASO, Atendimento, updateAtendimento } = useAtendimentoPage();
    const { ReloadHistorico } = useHistoricoContext();

    const { execute: CancelarCaso, loading: cancelarCasoLoading } =
        useAsyncCallback(CancelarCasoController);

    function handleJustificativaCancelamentoFinalizarCaso(
        formData: ICancelarCaso
    ) {
        CancelarCaso({
            ...formData,
            Justificativa: formData.Justificativa,
            ID_CASO: ID_CASO,
            ID_ETAPA_TIPO_CASO: Atendimento?.ID_ETAPA_TIPO_CASO,
            ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO:
                Atendimento?.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO,
        }).then(() => {
            props.setShow(false);
            updateAtendimento();
            ReloadHistorico();
        });
    }

    return (
        <>
            <UnForm handleSubmit={handleJustificativaCancelamentoFinalizarCaso}>
                <UnForm.Textarea
                    label="Justificativa"
                    name="Justificativa"
                    registerOptions={{ required: "Insira uma justificativa" }}
                />
                <UnForm.SubmitButton
                    loading={cancelarCasoLoading}
                    wrapperClassName="d-flex col-12 justify-content-end mt-3 mr-0 p-0"
                    disabled={cancelarCasoLoading}
                    className="col-12"
                    icon={faPaperPlane}
                    color="primary"
                    loadingSize="sm"
                >
                    Confirmar fechamento
                </UnForm.SubmitButton>
            </UnForm>
        </>
    );
}
